// GENERATED by scripts/build-mobile-textures.mjs. Do not edit by hand.
// Files under public/textures/ with a phone-sized copy in public/textures/mobile/
// (long edge 2048, the gain map 2560); mobileTextureUrl in src/textureFormat.js.
export const MOBILE_TEXTURES = new Set([
  "ceres.jpg",
  "charon.jpg",
  "deimos.jpg",
  "dione.jpg",
  "earth.jpg",
  "earth_bump.jpg",
  "earth_clouds.jpg",
  "earth_imagery_gain.webp",
  "earth_night.jpg",
  "earth_normal.jpg",
  "earth_ocean.webp",
  "ed138.jpg",
  "ed138_height.jpg",
  "ed138_normal.webp",
  "eris.jpg",
  "eris_height.jpg",
  "eris_normal.webp",
  "haumea.jpg",
  "haumea_height.jpg",
  "haumea_normal.webp",
  "jupiter.jpg",
  "makemake.jpg",
  "makemake_height.jpg",
  "makemake_normal.webp",
  "mars.jpg",
  "mars_bump.jpg",
  "mercury.jpg",
  "mercury_bump.jpg",
  "moon.jpg",
  "moon_bump.jpg",
  "phobos.jpg",
  "pluto.jpg",
  "rhea.jpg",
  "saturn.jpg",
  "sedna.jpg",
  "sedna_height.jpg",
  "sedna_normal.webp",
  "sun_8k.jpg",
  "venus.jpg"
]);
